var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.closeMenu,
          expression: "closeMenu",
        },
      ],
      class: [
        "input-item-box",
        _vm.focused ? "input-item-box-focus" : "",
        !_vm.passValidate ? "error-border" : "",
      ],
      on: { click: _vm.focusInput },
    },
    [
      _c(
        "span",
        { staticClass: "input-item-content-box" },
        [
          _vm._l(_vm.checkedTagArr, function (item, index) {
            return _c(
              "span",
              {
                key: item + Math.random(),
                class: [
                  "input-item-checked",
                  _vm.deleteFlag && index == _vm.checkedTagArr.length - 1
                    ? "inputitem-delete"
                    : "",
                ],
              },
              [
                _vm._v(_vm._s(item) + " "),
                _c("i", {
                  staticClass: "el-icon-close",
                  on: {
                    click: function ($event) {
                      return _vm.deleteItem(item)
                    },
                  },
                }),
              ]
            )
          }),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy",
                value: _vm.inputValue,
                expression: "inputValue",
                modifiers: { lazy: true },
              },
            ],
            ref: "inputItem",
            staticClass: "custom-input",
            attrs: {
              type: "text",
              placeholder: _vm.checkedTagArr.length > 0 ? "" : _vm.placeholder,
              maxlength: _vm.constraint.lengthMax,
            },
            domProps: { value: _vm.inputValue },
            on: {
              input: _vm.handelInput,
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.checkedContent.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k(
                      $event.keyCode,
                      "backspace",
                      undefined,
                      $event.key,
                      undefined
                    )
                  ) {
                    return null
                  }
                  return _vm.deleteLast.apply(null, arguments)
                },
              ],
              focus: _vm.focus,
              blur: _vm.blur,
              compositionstart: function ($event) {
                _vm.hasValue = false
              },
              compositionend: function ($event) {
                _vm.hasValue = true
              },
              change: function ($event) {
                _vm.inputValue = $event.target.value
              },
            },
          }),
        ],
        2
      ),
      _vm.contentShow
        ? _c(
            "span",
            {
              staticClass: "input-item-content",
              on: { click: _vm.checkedContent },
            },
            [_vm._v(_vm._s(_vm.inputValue))]
          )
        : _vm._e(),
      _vm.clearShow
        ? _c("i", {
            staticClass: "clear-all el-icon-error",
            on: { click: _vm.clearAllChecked },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }